import {useSelector} from 'react-redux';

import {selectConfiguration} from 'coreStore/data/configurations';
import {RootState} from '../store/types';
import {ConfigurationsState} from '../store/data/configurations/types';

type DotNotation<T, Prefix extends string = ''> = {
	[K in keyof T & string]: T[K] extends object
		? DotNotation<T[K], `${Prefix}${K}.`> | `${Prefix}${K}`
		: `${Prefix}${K}`;
}[keyof T & string];

/**
 * Hook for handling the configurations changes across different sites
 */
const useConfiguration = <T extends DotNotation<ConfigurationsState>>(prop: T): any => {
	return useSelector((state: RootState) => selectConfiguration(state, prop));
};

export default useConfiguration;
